import React from 'react';
import OpportunityProvider, { OpportunityContext } from "../../providers/OpportunityProvider";
import {Outlet, useLocation} from "react-router-dom";
import { Helmet } from "react-helmet";
import PageNotAllowed from "../../components/errors/PageNotAllowed";
import {useAuth} from "../../providers/AuthProvider";


const OpportunityLayout = () => {
    const { pathname } = useLocation();

    const {auth} = useAuth();
    const projectPageTitle = (projectName) => {
        if (pathname.includes('/proposal')) {
            return `Proposal for ${projectName}`
        } else if (pathname.includes('/brief')) {
            return `Brief for ${projectName}`
        } else if (pathname.includes('/sign-contract')) {
            return `Contract for ${projectName} `
        } else if (pathname.includes('/review-project-brief/role-overview')) {
            return `Role Overview for ${projectName}`
        } else if (pathname.includes('review-project-brief/client-and-project-overview')) {
            return `Project Overview for ${projectName}`
        } else if (pathname.includes('/review-project-brief/project-timing')) {
            return `Project Timing for ${projectName}`
        } else if (pathname.includes('/pursuit-status')) {
            return `Project Status for ${projectName}`
        } else if (pathname.includes('/sign-contract')) {
            return `Contract for ${projectName} `
        }
        return projectName
    }

    if (auth.isTalent() && !auth.isProfileApproved()) {
        return <PageNotAllowed redirect="/talent/dashboard" message="Your profile must be approved before accessing this page."/>;
    }
    return (
        <OpportunityProvider>
            <OpportunityContext.Consumer>
                {({ opportunity }) => (opportunity?.project?.name ? (
                    <Helmet>
                        <title>{projectPageTitle(opportunity.project.name)} | Wripple</title>
                    </Helmet>
                ) : undefined)}
            </OpportunityContext.Consumer>

            <Outlet />
        </OpportunityProvider>
    );
};

export default OpportunityLayout;